module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "quiz-item card"
  }, _vm._l((_vm.question.list), function(questionObj, objIndex) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showQuestionObj(objIndex)),
        expression: "showQuestionObj(objIndex)"
      }]
    }, [_c('h4', {
      staticClass: "card-header"
    }, [(questionObj.featured) ? _c('img', {
      attrs: {
        "src": './static/images/featured/' + questionObj.featured + '.png'
      }
    }) : _vm._e(), _vm._v("\n\t  \t\t" + _vm._s(questionObj.question) + "\n\t  \t")]), _vm._v(" "), _c('div', {
      staticClass: "options card-block"
    }, [_vm._l((questionObj.options), function(option) {
      return _c('div', [_c('input', {
        attrs: {
          "type": "radio",
          "id": option.image,
          "name": _vm.name
        },
        domProps: {
          "value": option.image
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "btn btn-lg btn-primary btn-block",
        attrs: {
          "for": option.image
        },
        on: {
          "click": function($event) {
            _vm.selectAnswer(_vm.question, option)
          }
        }
      }, [_vm._m(0, true), _vm._v("\n\t\t\t       " + _vm._s(option.option) + "\n\t\t       ")])])
    }), _vm._v(" "), _c('div', {
      staticClass: "paging"
    }, [_c('i', {
      staticClass: "fa fa-chevron-left",
      class: {
        active: _vm.showPrev
      },
      on: {
        "click": _vm.prevQuestion
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.index + 1) + " / " + _vm._s(_vm.length))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-chevron-right",
      class: {
        active: _vm.showNext
      },
      on: {
        "click": _vm.nextQuestion
      }
    })])], 2)])
  }))
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn-label"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-271fbee6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuizItem.vue
// module id = 83
// module chunks = 1